import type { ReactNode } from 'react'

import { GenufitDirectionCWordmark } from './GenufitDirectionCWordmark'

type GenufitAuthBrandStackProps = {
  mark: ReactNode
  className?: string
  /** Direction C wordmark under the mark; off when a page heading already names the product. */
  showWordmark?: boolean
}

export function GenufitAuthBrandStack({
  mark,
  className,
  showWordmark = true,
}: GenufitAuthBrandStackProps) {
  return (
    <div className={`flex flex-col items-center gap-3 sm:gap-4 ${className ?? ''}`}>
      {mark}
      {showWordmark ? <GenufitDirectionCWordmark /> : null}
    </div>
  )
}
